import {
  convertLocationToPlaceFormat,
  convertModeToFormMode,
  convertModeToVehicleType,
} from '@/components/modules/emissions/calculator/form/utils';
import { ItineraryModel } from '@/lib/models/itinerary/types';
import { LocationModel } from '@/lib/models/location/types';
import { CargoOption, EmissionsFormInputsInterface } from '@/types';

import {
  createEmissionsSegment,
  createFinalDestinationSegment,
  extractVehicleFromSegment,
  getCargoItemsForMode,
  processStopOffs,
} from '../utils';

const transformItineraryToCalculatorFormData = ({
  locations,
  itinerary,
  cargoParams,
}: {
  locations: LocationModel[];
  itinerary: ItineraryModel;
  cargoParams?: CargoOption;
}): EmissionsFormInputsInterface => {
  const { type, legs } = itinerary;

  const findLocation = (locationId: string): LocationModel | null => {
    return locations.find((location) => location.id === locationId) || null;
  };

  // Transform legs to form segments
  const segments = legs.map((leg) => {
    const originLocation = findLocation(leg.fromId);
    const vehicleId = extractVehicleFromSegment(leg.vehicleId, leg.mode);

    // Convert stop IDs to location objects
    const stopOffs = processStopOffs(leg.stopIds, locations, false);

    return createEmissionsSegment({
      vehicleType: convertModeToVehicleType(leg.mode),
      vehicleId,
      flightNumber: leg.flightNumber || '',
      distance: 0,
      origin: originLocation ? convertLocationToPlaceFormat(originLocation) : undefined,
      stopOffs,
    });
  });

  // Add final destination segment
  if (legs.length > 0) {
    const lastLeg = legs[legs.length - 1];
    const destinationLocation = findLocation(lastLeg.toId);

    if (destinationLocation) {
      segments.push(createFinalDestinationSegment(destinationLocation));
    }
  }

  return {
    mode: convertModeToFormMode(type),
    cargoItems: getCargoItemsForMode(type, cargoParams),
    segments,
  };
};

export { transformItineraryToCalculatorFormData };
